module.exports = __webpack_public_path__ + "01_bob_gold.dc108373.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_bob_gold.png
// module id = WedS
// module chunks = 0